<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nwtQve/tc-custom/9780226160191.jpg?1722579937330" alt="This image is the cover for the book Pursuit of Power"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pursuit of Power
      </h1>
      <p class="bookDescription body article font2">
        <p>In this magnificent synthesis of military, technological, and social history, William H. McNeill explores a whole millennium of human upheaval and traces the path by which we have arrived at the frightening dilemmas that now confront us. McNeill moves with equal mastery from the crossbow—banned by the Church in 1139 as too lethal for Christians to use against one another—to the nuclear missile, from the sociological consequences of drill in the seventeenth century to the emergence of the military-industrial complex in the twentieth. His central argument is that a commercial transformation of world society in the eleventh century caused military activity to respond increasingly to market forces as well as to the commands of rulers. Only in our own time, suggests McNeill, are command economies replacing the market control of large-scale human effort. The Pursuit of Power does not solve the problems of the present, but its discoveries, hypotheses, and sheer breadth of learning do offer a perspective on our current fears and, as McNeill hopes, "a ground for wiser action."<br/>  </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William H. McNeill
      </h2>
      
      <p class="authorDescription body article"><B>William H. McNeill</B> is the Robert A. Millikan Distinguished Service Professor Emeritus in the Department of History and the College at the University of Chicago. His many books include <I>The Pursuit of Power, The Rise of the West,</I> and <I>Mythistory and Other Essays</I>, all published by the University of Chicago Press.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78623f22